import React from "react";

interface Props {
  value: string
}

const ReadonlyBoolean = ({ value }: Props) => {
  if (value === "true") return <i className="icon-true"></i>;
  if (value === "false" || value === null) return <i className="icon-false"></i>;

  return <></>;
};

export default ReadonlyBoolean;